/* eslint-disable */
import React, { useState } from "react";
import {
  Container,
  Grid,
  Box,
  Typography,
  Paper,
  Button,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  Stepper,
  Step,
  StepLabel,
  StepContent,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { fetchCurrentLocation } from "../redux/locationSlice";
import {
  selectCartItems,
  selectCartTotal,
  addItemToCart,
  removeItemFromCart,
  updateItemQuantity,
} from "../redux/cartSlice";

const indianStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

const Checkout = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    pincode: "",
    locality: "",
    address: "",
    city: "",
    state: "",
  });
  const [activeStep, setActiveStep] = useState(0);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Initialize useNavigate
  const cartItems = useSelector(selectCartItems);
  const total = useSelector(selectCartTotal);
  const deliveryCharges = 50;

  const formattedTotal = Number(total).toFixed(2);
  const totalAmount = (Number(formattedTotal) + deliveryCharges).toFixed(2);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSaveAddress = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleGetCurrentLocation = () => {
    dispatch(fetchCurrentLocation());
  };

  const generateDeliveryDate = () => {
    const deliveryDays = Math.floor(Math.random() * 7) + 1;
    const deliveryDate = new Date();
    deliveryDate.setDate(deliveryDate.getDate() + deliveryDays);

    const month = deliveryDate.toLocaleString("en-US", { month: "long" });
    const day = deliveryDate.getDate();

    return `${month} ${day}`;
  };

  const handleIncreaseQuantity = (itemId) => {
    dispatch(addItemToCart(itemId));
  };

  const handleDecreaseQuantity = (itemId) => {
    const existingItem = cartItems.find((item) => item.id === itemId);
    if (existingItem.quantity === 1) {
      dispatch(removeItemFromCart(itemId));
    } else {
      dispatch(updateItemQuantity(itemId, existingItem.quantity - 1));
    }
  };

  const handleRemoveItem = (itemId) => {
    dispatch(removeItemFromCart(itemId));
  };

  const handleContinue = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handlePlaceOrder = () => {
    // Generate order details
    const orderDetails = {
      items: cartItems,
      deliveryDate: generateDeliveryDate(),
    };

    // Navigate to the thank you page with order details
    navigate('/thank-you', { state: { order: orderDetails } });
  };

  const steps = [
    {
      label: "Delivery Address",
      content: (
        <Box component="form" noValidate sx={{ mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleGetCurrentLocation}
          >
            Get Current Location
          </Button>
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              label="Name"
              fullWidth
              margin="normal"
              required
              name="name"
              value={formData.name}
              onChange={handleInputChange}
            />
            <TextField
              label="Mobile Number"
              fullWidth
              margin="normal"
              required
              name="mobile"
              value={formData.mobile}
              onChange={handleInputChange}
            />
          </Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              label="Pincode"
              fullWidth
              margin="normal"
              required
              name="pincode"
              value={formData.pincode}
              onChange={handleInputChange}
            />
            <TextField
              label="Locality"
              fullWidth
              margin="normal"
              required
              name="locality"
              value={formData.locality}
              onChange={handleInputChange}
            />
          </Box>
          <TextField
            label="Address (House No, Building, Street, Area)"
            fullWidth
            margin="normal"
            required
            name="address"
            value={formData.address}
            onChange={handleInputChange}
          />
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              label="City"
              fullWidth
              margin="normal"
              required
              name="city"
              value={formData.city}
              onChange={handleInputChange}
            />
            <FormControl fullWidth margin="normal" required>
              <Select
                label="State"
                name="state"
                value={formData.state}
                onChange={handleInputChange}
              >
                {indianStates.map((state) => (
                  <MenuItem key={state} value={state}>
                    {state}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 3 }}
            onClick={handleSaveAddress}
          >
            Save Address and Deliver Here
          </Button>
        </Box>
      ),
    },
    {
      label: "Order Summary",
      content: (
        <>
          <Box>
            {cartItems.map((item) => (
              <Paper
                key={item.id}
                sx={{ p: 2, mb: 2, display: "flex", alignItems: "center" }}
              >
                <img
                  src={item.imgSrc}
                  alt={item.title}
                  style={{ width: 100, height: 100, marginRight: 20 }}
                />
                <Box>
                  <Typography variant="body1">{item.title}</Typography>
                  <Typography variant="body2">
                    Price: ₹{item.price}{" "}
                    <s style={{ color: "#aaa" }}>₹{item.oldPrice}</s>
                  </Typography>
                  <Box
                    sx={{ display: "flex", alignItems: "center", marginTop: 1 }}
                  >
                    <Button
                      sx={{
                        border: "2px solid black",
                        borderRadius: "50%",
                        width: 36,
                        height: 36,
                        minWidth: 0,
                      }}
                      color="primary"
                      onClick={() => handleDecreaseQuantity(item.id)}
                    >
                      -
                    </Button>
                    <Typography
                      variant="body2"
                      sx={{
                        marginX: 1,
                        border: "1px solid #ccc",
                        px: 2,
                        py: 1,
                      }}
                    >
                      {item.quantity}
                    </Typography>
                    <Button
                      sx={{
                        border: "2px solid black",
                        borderRadius: "50%",
                        width: 36,
                        height: 36,
                        minWidth: 0,
                      }}
                      color="primary"
                      onClick={() => handleIncreaseQuantity(item.id)}
                    >
                      +
                    </Button>
                  </Box>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => handleRemoveItem(item.id)}
                    sx={{ mt: 2 }}
                  >
                    Remove
                  </Button>
                </Box>
                <Typography variant="body2" sx={{ ml: 3, mb: "115px" }}>
                  Delivery by {generateDeliveryDate()} | Free
                </Typography>
              </Paper>
            ))}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              p: 2,
              border: "1px solid #ddd",
              borderRadius: 1,
            }}
          >
            <Typography variant="body1">
              Order confirmation email will be sent to:
            </Typography>
            <TextField
              size="small"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              sx={{
                "& .MuiInputBase-root": {
                  border: "none",
                  outline: "none",
                },
                "& .MuiInputBase-input": {
                  padding: "0",
                  borderBottom: "2px solid #ccc",
                  "&:focus": {
                    borderBottom: "2px solid #000",
                  },
                },
                "& .MuiInputLabel-root": {
                  top: -10,
                  "&.Mui-focused": {
                    color: "transparent",
                  },
                },
                "& .MuiInputBase-input:focus": {
                  outline: "none",
                },
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleContinue}
            >
              Continue
            </Button>
          </Box>
        </>
      ),
    },
    {
      label: "Payment Options",
      content: (
        <Box>
          <FormControl component="fieldset">
            <RadioGroup
              name="paymentMethod"
              value={selectedPaymentMethod}
              onChange={(e) => setSelectedPaymentMethod(e.target.value)}
            >
              <FormControlLabel value="upi" control={<Radio />} label="UPI" />
              <FormControlLabel
                value="card"
                control={<Radio />}
                label="Credit / Debit Card"
              />
              <FormControlLabel
                value="netbanking"
                control={<Radio />}
                label="Net Banking"
              />
              <FormControlLabel
                value="cod"
                control={<Radio />}
                label="Cash on Delivery"
              />
            </RadioGroup>
          </FormControl>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Button variant="outlined" color="primary" fullWidth sx={{ mt: 2 }}>
              Add Gift Card
            </Button>
            {selectedPaymentMethod && (
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mb: 4 }}
                onClick={handlePlaceOrder} // Add the onClick handler here
              >
                Place Order
              </Button>
            )}
          </div>
        </Box>
      ),
    },
  ];

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Checkout
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((step, index) => (
              <Step key={step.label}>
                <StepLabel>{step.label}</StepLabel>
                <StepContent>{step.content}</StepContent>
              </Step>
            ))}
          </Stepper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Price Details
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Typography variant="body1">
                Price ({cartItems.length} items): ₹{formattedTotal}
              </Typography>
              <Typography variant="body1">
                Delivery Charges: ₹{deliveryCharges}
              </Typography>
            </Box>
            <Typography variant="h6" gutterBottom>
              Total Amount: ₹{totalAmount}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Checkout;
